var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 13,
    viewBox: "0 0 10 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "icon-body",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.86603 4.79395H8.09204C8.84404 4.79395 9.45905 5.40901 9.45905 6.16101V10.979C9.45905 11.731 8.84404 12.3459 8.09204 12.3459H1.86603C1.11403 12.3459 0.499023 11.731 0.499023 10.979V6.16101C0.499023 5.40901 1.11403 4.79395 1.86603 4.79395Z",
    fill: "#A8C0FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "icon-top",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.93207 1.48096C6.14607 1.48096 7.13806 2.47301 7.13806 3.68701V7.88196C7.13806 9.09596 6.14607 10.088 4.93207 10.088C3.71807 10.088 2.72607 9.09596 2.72607 7.88196V3.68701C2.72607 2.47401 3.71907 1.48096 4.93207 1.48096Z",
    stroke: "#A8C0FF",
    strokeWidth: 1.023,
    strokeMiterlimit: 22.9256
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.53a881bd928bafcc3aff026329431db2.svg";
export { ForwardRef as ReactComponent };